import axios from 'axios'

// let baseURL
// console.log('process.env', process.env.NODE_ENV)
// if (process.env.NODE_ENV === 'development') {
//   baseURL = 'http://test-api.chxinge.com'
// } else {
//   baseURL = 'https://prod-api.chxinge.com'
// }
// baseURL = 'http://test-api.chxinge.com'
// baseURL = 'https://prod-api.chxinge.com'
// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API_URL,
  // baseURL: 'http://test-api.chxinge.com', // url = base url + request url
  // baseURL: 'https://prod-api.chxinge.com', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    if (parseInt(res.code) !== 0) {

    }
    return res
  },
  error => {
    console.log('err' + error) // for debug

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/request/index.js